<template>
  <v-expansion-panels style="background-color: #eee; margin-top: 10px; z-index: 0" class="custom-panel-content">
    <v-expansion-panel>
      <v-expansion-panel-header style="background-color: #eee;">
        <div>
          <v-icon>mdi-image</v-icon>
          <b style="font-size: 14px; font-weight: 600; padding-left: 10px">
            {{ label }} : {{ value }}
          </b>
        </div>


      </v-expansion-panel-header>
      <v-expansion-panel-content>


        <v-card style="background-color: #eee" v-if="isNew">
          <v-card-text class="text-h5 font-weight-bold">
            <core-file-upload ref="fileUpload" accept="image/*" @input="storeImage" label="Trascina qua l'immagine" />
          </v-card-text>
        </v-card>


        <v-card style="background-color: #eee" v-if="!isNew">
          <v-card-text class="text-h5 font-weight-bold">
            <v-img :src="imgPath" @click="copyUrlToClipboard()"></v-img>
          </v-card-text>
          <v-card-actions>
            <v-btn small color="lighten-2 warning" @click="deleteImage">
              <v-icon small>mdi-delete</v-icon>
              Remove Image
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
let { post } = require("@/api/base_entity");
import { mapActions } from 'vuex'

export default {
  props: {
    value: { type: [String] },
    label: { type: String, default: null }
  },
  data() {
    return {
      base64: null,
      imgHeight: 320,
      imgWidth: 480,
      loadingStore: false,
    };
  },
  watch: {
  },
  mounted() {
    this.getConfig()
  },
  computed: {
    isNew() {
      return !this.value;
    },
    imgPath() {
      return (
        this.$store.getters.s3BaseUrl + this.value
      )
    },
  },
  methods: {
    ...mapActions('app', ['getConfig']),
    storeImage(val) {

      this.loadingStore = true;

      return post("image", { base64: val.base64, name: val.name })
        .then((ret) => {

          this.$emit('input', ret.name);

          this.$root.$emit('openSnackbar', {
            message: 'Immagine caricata con successo!',
            color: 'success'
          })
          this.$refs.fileUpload.setBusy(false)
        }).
        catch((msg) => {
          this.$root.$emit('openSnackbar', {
            message: 'Si è verificato un errore durante il caricamento del file : ' + msg.response.data.message || 'Error',
            color: 'error'
          })
        })
        .finally(() => {
          this.loadingStore = false;
        });

    },
    deleteImage() {
      this.$emit('input', null);
      this.base64 = null
    },
    copyUrlToClipboard() {
      const url = this.imgPath;
      navigator.clipboard.writeText(url).then(() => {
        this.$root.$emit('openSnackbar', {
          message: 'Image URL copied to clipboard!',
          color: 'success'
        })
      }, () => {
        this.$root.$emit('openSnackbar', {
          message: 'Failed to copy image URL to clipboard!',
          color: 'error'
        })
      });
    }
  },
};
</script>

<style>
.imageComponent {
  background-color: rgb(102, 102, 102);
}
.custom-panel-content .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>